import {get} from 'lodash';

export default (state: any, {hasError}: any) => ({
  ...state,
  healthcare: {
    ...get(state, 'healthcare', {}),
    hasError,
  },
});
